
import { SalesPromoFormProps } from './SalesPromoForm.types'
import { Button, Stack } from 'src/app/components';
import { useSalesPromoForm4 } from './SalesPromoForm4.hook';
import { Refs } from 'src/app/utils/refs-utils';
import { usePermissions } from 'src/app/hooks/permissions-hook';
import SalesPromoDetailTabGeneralInfo from '../SalesPromoDetail/SalesPromoDetailTabGeneral';

export function SalesPromoForm4(props: Readonly<SalesPromoFormProps>) {

    const state = useSalesPromoForm4(props.id)
    const permission = usePermissions()

    function clickSubmit() {
        const { status } = props.currentDetail || {};
    
        const handleSave = () => props.save?.();
    
        if (status === 'ACTIVE' || status === 'PENDING') {
            Refs.pageToast.show({
                severity: 'success',
                message: 'Sales Promotion successfully edited.',
            });
            handleSave();
        } else {
            state.submit.mutate(props.id!, { onSuccess: handleSave });
        }
    }    

    return (
        <>
            <Stack className='px-8 pt-6'>
                <SalesPromoDetailTabGeneralInfo data={state.salesPromoDetail.data} useStatus={false} />
            </Stack>
            <Stack
                className={'px-8 py-6'}
                direction="row"
                gap={4}
            >
                <Stack
                    direction="row"
                    justify='end'
                    gap={4}
                >
                    <Button loading={state.submit.isLoading} variant='outlined' onClick={() => { props.backward && props.backward() }}>Previous</Button>
                    {permission.setVisibleByAccess(
                        ['manage_campaign_sales_promo.create', 'manage_campaign_sales_promo.update'],
                    <Button loading={state.submit.isLoading} onClick={clickSubmit}>Save Sales Promotion</Button>)}
                </Stack>
            </Stack>
        </>
    )
}
